import NumberSystemApi from '@num/service/NumberSystemApi'
import Order from '@num/model/Order'
import store from '@num/store/ordernumber'
import { config } from '@num/config'
import { fixOrderList } from '@num/service/numbersystemApiFix.js'
import { eventhub, EVENT_ORDER_PICKUP } from '@num/store/eventhub'

const api = new NumberSystemApi()

var pendingRequests = 0
var failedUpdates = 0
var failedReported = false

export function updateOrderList(filter) {
  console.debug("updateOrderList...")
  store.state.loadingList = true
  pendingRequests = true
  return api
    .order(filter, config.store)
    .then((list) => {
      //handle pending requests
      pendingRequests --
      if(pendingRequests > 0) {
        //do not update
        return
      }
      store.state.loadingList = false

      //we do the dirty cleanup in an external file
      fixOrderList(list)

      const pickupOrders = [];
      list.forEach((order) => {
        let current = store.state.orderList.findByAttr("id", order.id)
        if (current) {
          current.update(order)
        } else {
          current = new Order(order);
          store.state.orderList.add(current)
        }

        if (current.status && current.status.includes(config.ORDER_STATUS_PICKUP_PREFIX)) {
          pickupOrders.push(current);
        }
      })

      store.state.orderList
        .getListDifferenceByAttr("id", list)
        .forEach((remove) => store.state.orderList.remove(remove))

      console.debug("updateOrderList done.", store.state.orderList)

      eventhub.$emit(EVENT_ORDER_PICKUP, pickupOrders);

      return Promise.resolve("udpate done")
    }, (err) => {
      store.state.loadingList = false
      failedUpdates++
      if (failedUpdates > config.ORDERLIST_API_RETRIES && failedReported == false) {
        failedReported = true
        return Promise.reject(err)
      } else if(failedReported == false || failedUpdates > 1) {
        console.warn("No network, retry: %s", failedUpdates)
      } else {
        failedUpdates = 0
        failedReported = false
      }
      return Promise.resolve()
    })
}

export function updateOrder(order) {
  let change = {id: order.id, status: order.status}
  let currentOrder = store.state.orderList.findByAttr("id", order.id)

  pendingRequests ++

  currentOrder.update(change)
  
  return api
    .orderUpdate(order)
    .then((res) => {
      pendingRequests --
      if (store.state.orderIntervalTime > 0) {
        startUpdateOrderListInterval(store.state.orderFilter, store.state.orderIntervalTime)
      }
    }, (err) => {
      pendingRequests --
      return Promise.reject(err)
    })
}
export function advanceOrder(order) {
  // new -> production -> box-[0-5]
  let states = config.ORDER_STATUS
  //generate a [1, 2, 3, 4, 5, 6]
  let boxAdvanceOrder = Array.from(new Array(config.ORDERBOXES), (v, i) => i + 1)
  
  if (config.ORDERBOXES_FILLBOTTOM_FIRST) {
    //TODO: this is hardcoded
    let boxCount = 3 // 1,2,3 <-> 4,5,6
    let boxIdx = boxAdvanceOrder.indexOf(1)
    boxAdvanceOrder.splice(boxIdx + boxCount, 0, ...boxAdvanceOrder.splice(boxIdx, boxCount))
  }

  let statusIdx = states.indexOf(order.status)
  let newStatus = null
  let match = /(in_box_|in_prep_)(\d)/.exec(order.status)

  //first split up the number and status                               
  if (match) {
    //if its a prepare state we check if the same pickup box is free
    if (match[1] == config.ORDER_STATUS_PREP_PREFIX) {
      if (config.FEATURE_ORDERBOXES) {
        newStatus = config.ORDER_STATUS_PICKUP_PREFIX + match[2]
        if (store.state.orderList.findByAttr("status", newStatus) != null) {
          return Promise.reject({error: true, code: 2, message: "no free slots"})
        }
      } else {
        newStatus = config.ORDER_STATUS_PICKUP_PREFIX + '1'
      }
    } else {
      //move to done if not prepare (should be in_box)
      newStatus = "done"
    }
  } else if (["new", "in_production"].includes(order.status)) {
    let freeOrderNum = null
    if (config.FEATURE_PREPAREBOXES) {
      //we have prep boxes
      if (order.status == "new" || order.status == "in_production") {
        if (order.status == "in_production" || config.ORDERBOXES_ADVANCE_TO_PREPBOX) {
          //to prep box or directly to prep box
          freeOrderNum = boxAdvanceOrder.find(v => {
            //we check if the same prep and pickup slot is free
            return store.state.orderList.findByAttr("status", config.ORDER_STATUS_PREP_PREFIX + v) == null
              && store.state.orderList.findByAttr("status", config.ORDER_STATUS_PICKUP_PREFIX + v) == null
          })

          //no prepbox free, so we fallback to production
          if (freeOrderNum != null) {
            newStatus = config.ORDER_STATUS_PREP_PREFIX
          } else {
            newStatus = "in_production"
          }
        } else {
          newStatus = "in_production"
        }
      } else {
        newStatus = config.ORDER_STATUS_PREP_PREFIX
      }
    } else {
      //advance state for normal new and in_production
      if (order.status == "new") {
        newStatus = "in_production"
      } else {
        newStatus = config.ORDER_STATUS_PICKUP_PREFIX
      }
    }
    if (newStatus.includes(config.ORDER_STATUS_PREP_PREFIX) || newStatus.includes(config.ORDER_STATUS_PICKUP_PREFIX)) {
      if (config.FEATURE_ORDERBOXES) {
        //if its a numberstatus, find the free box, if we have found one earlier, use it
        if (freeOrderNum == null) {
          freeOrderNum = boxAdvanceOrder.find(v => {
            return store.state.orderList.findByAttr("status", newStatus + v) == null
          })
        }
        if (freeOrderNum != null) {
          newStatus += freeOrderNum
        } else {
          //throw an error if no box is free
          console.info("newstatus not free", newStatus)
          return Promise.reject({error: true, code: 2, message: "no free slots"})
        }
      } else {
        newStatus = config.ORDER_STATUS_PICKUP_PREFIX + "1"
      }
    }
  }

  if (newStatus) {
    console.info("move to new state", order.id, newStatus)
    return updateOrder({id: order.id, status: newStatus})
  }
  return Promise.reject({error: true, code: 3, message: "invalid state"})
}

export function startUpdateOrderListInterval(filter = undefined, time = 5000) {
  stopUpdateOrderListInterval()

  //TODO: this is a cheesy way to store that info
  if (filter == null) {
    let filters = ["new", "in_production"]
    if (config.FEATURE_PREPAREBOXES) {
      filters.push(
        ...Array.from(new Array(config.ORDERBOXES), (v, i) => config.ORDER_STATUS_PREP_PREFIX + (i + 1))
      )
    }
    filters.push(
      ...Array.from(new Array(config.ORDERBOXES), (v, i) => config.ORDER_STATUS_PICKUP_PREFIX + (i + 1))
    )
    //if we have postorders and are in the control page
    //HACK: currently we do not know another shorter and more relieable way to detect the current component
    let isControlPage = window.location.pathname.indexOf("/control") >= 0
    if (config.FEATURE_PASTORDERS && isControlPage) {
      filters.push("done")
    }
    store.state.orderFilter = filters.join(",")
  } else {
    store.state.orderFilter = filter
  }
  store.state.orderIntervalTime = time

  //TODO: rebuild this for error handling
  updateOrderList(filter)
  store.state.updateOrderListInterval = setInterval(updateOrderList, time, store.state.orderFilter)
}
export function stopUpdateOrderListInterval() {
  clearInterval(store.state.updateOrderListInterval)
  store.state.updateOrderListInterval = -1
}
